var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.888c.517 0 .937.42.937.937v3.053a.938.938 0 0 1-1.874 0V7.825c0-.517.42-.937.937-.937zm-1.777-5.26a2.066 2.066 0 0 1 3.554 0l5.662 9.538a2.065 2.065 0 0 1-1.777 3.122H2.338a2.067 2.067 0 0 1-1.777-3.122zm2.117.482a.666.666 0 0 0-.913.232l-5.663 9.539a.667.667 0 0 0 .574 1.007h11.324a.666.666 0 0 0 .574-1.007L8.573 2.342a.664.664 0 0 0-.233-.232zM8 4.196A1.093 1.093 0 1 1 8 6.38a1.093 1.093 0 0 1 0-2.184z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgIconWarning;